"use strict";
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var util_1 = require("../../utils/util");
var logging_1 = require("../../utils/logging");
var collections_1 = require("../../collections/collections");
var httpclient_1 = require("../../net/httpclient");
var odata_1 = require("./odata");
var caching_1 = require("./caching");
var pnplibconfig_1 = require("../../configuration/pnplibconfig");
var Queryable = (function () {
    function Queryable(baseUrl, path) {
        this._query = new collections_1.Dictionary();
        this._batch = null;
        if (typeof baseUrl === "string") {
            var urlStr = baseUrl;
            if (util_1.Util.isUrlAbsolute(urlStr) || urlStr.lastIndexOf("/") < 0) {
                this._parentUrl = urlStr;
                this._url = util_1.Util.combinePaths(urlStr, path);
            }
            else if (urlStr.lastIndexOf("/") > urlStr.lastIndexOf("(")) {
                var index = urlStr.lastIndexOf("/");
                this._parentUrl = urlStr.slice(0, index);
                path = util_1.Util.combinePaths(urlStr.slice(index), path);
                this._url = util_1.Util.combinePaths(this._parentUrl, path);
            }
            else {
                var index = urlStr.lastIndexOf("(");
                this._parentUrl = urlStr.slice(0, index);
                this._url = util_1.Util.combinePaths(urlStr, path);
            }
        }
        else {
            var q = baseUrl;
            this._parentUrl = q._url;
            var target = q._query.get("@target");
            if (target !== null) {
                this._query.add("@target", target);
            }
            this._url = util_1.Util.combinePaths(this._parentUrl, path);
        }
    }
    Queryable.prototype.concat = function (pathPart) {
        this._url += pathPart;
    };
    Queryable.prototype.append = function (pathPart) {
        this._url = util_1.Util.combinePaths(this._url, pathPart);
    };
    Queryable.prototype.addBatchDependency = function () {
        if (this.hasBatch) {
            return this._batch.addBatchDependency();
        }
        return function () { return null; };
    };
    Object.defineProperty(Queryable.prototype, "hasBatch", {
        get: function () {
            return this._batch !== null;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Queryable.prototype, "parentUrl", {
        get: function () {
            return this._parentUrl;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Queryable.prototype, "query", {
        get: function () {
            return this._query;
        },
        enumerable: true,
        configurable: true
    });
    Queryable.prototype.inBatch = function (batch) {
        if (this._batch !== null) {
            throw new Error("This query is already part of a batch.");
        }
        this._batch = batch;
        return this;
    };
    Queryable.prototype.usingCaching = function (options) {
        if (!pnplibconfig_1.RuntimeConfig.globalCacheDisable) {
            this._useCaching = true;
            this._cachingOptions = options;
        }
        return this;
    };
    Queryable.prototype.toUrl = function () {
        return util_1.Util.makeUrlAbsolute(this._url);
    };
    Queryable.prototype.toUrlAndQuery = function () {
        var _this = this;
        var url = this.toUrl();
        if (this._query.count() > 0) {
            url += "?";
            var keys = this._query.getKeys();
            url += keys.map(function (key, ix, arr) { return (key + "=" + _this._query.get(key)); }).join("&");
        }
        return url;
    };
    Queryable.prototype.get = function (parser, getOptions) {
        if (parser === void 0) { parser = new odata_1.ODataDefaultParser(); }
        if (getOptions === void 0) { getOptions = {}; }
        return this.getImpl(getOptions, parser);
    };
    Queryable.prototype.getAs = function (parser, getOptions) {
        if (parser === void 0) { parser = new odata_1.ODataDefaultParser(); }
        if (getOptions === void 0) { getOptions = {}; }
        return this.getImpl(getOptions, parser);
    };
    Queryable.prototype.post = function (postOptions, parser) {
        if (postOptions === void 0) { postOptions = {}; }
        if (parser === void 0) { parser = new odata_1.ODataDefaultParser(); }
        return this.postImpl(postOptions, parser);
    };
    Queryable.prototype.postAs = function (postOptions, parser) {
        if (postOptions === void 0) { postOptions = {}; }
        if (parser === void 0) { parser = new odata_1.ODataDefaultParser(); }
        return this.postImpl(postOptions, parser);
    };
    Queryable.prototype.patch = function (patchOptions, parser) {
        if (patchOptions === void 0) { patchOptions = {}; }
        if (parser === void 0) { parser = new odata_1.ODataDefaultParser(); }
        return this.patchImpl(patchOptions, parser);
    };
    Queryable.prototype.delete = function (deleteOptions, parser) {
        if (deleteOptions === void 0) { deleteOptions = {}; }
        if (parser === void 0) { parser = new odata_1.ODataDefaultParser(); }
        return this.deleteImpl(deleteOptions, parser);
    };
    Queryable.prototype.getParent = function (factory, baseUrl, path) {
        if (baseUrl === void 0) { baseUrl = this.parentUrl; }
        var parent = new factory(baseUrl, path);
        var target = this.query.get("@target");
        if (target !== null) {
            parent.query.add("@target", target);
        }
        return parent;
    };
    Queryable.prototype.getImpl = function (getOptions, parser) {
        var _this = this;
        if (getOptions === void 0) { getOptions = {}; }
        if (this._useCaching) {
            var options = new caching_1.CachingOptions(this.toUrlAndQuery().toLowerCase());
            if (typeof this._cachingOptions !== "undefined") {
                options = util_1.Util.extend(options, this._cachingOptions);
            }
            if (options.store !== null) {
                var data_1 = options.store.get(options.key);
                if (data_1 !== null) {
                    return new Promise(function (resolve) { return resolve(data_1); });
                }
            }
            parser = new caching_1.CachingParserWrapper(parser, options);
        }
        if (!this.hasBatch) {
            var client = new httpclient_1.HttpClient();
            return client.get(this.toUrlAndQuery(), getOptions).then(function (response) {
                return _this.processHttpClientResponse(response, parser);
            });
        }
        else {
            return this._batch.add(this.toUrlAndQuery(), "GET", getOptions, parser);
        }
    };
    Queryable.prototype.postImpl = function (postOptions, parser) {
        var _this = this;
        if (!this.hasBatch) {
            var client = new httpclient_1.HttpClient();
            return client.post(this.toUrlAndQuery(), postOptions).then(function (response) {
                return _this.processHttpClientResponse(response, parser);
            });
        }
        else {
            return this._batch.add(this.toUrlAndQuery(), "POST", postOptions, parser);
        }
    };
    Queryable.prototype.patchImpl = function (patchOptions, parser) {
        var _this = this;
        if (!this.hasBatch) {
            var client = new httpclient_1.HttpClient();
            return client.patch(this.toUrlAndQuery(), patchOptions).then(function (response) {
                return _this.processHttpClientResponse(response, parser);
            });
        }
        else {
            return this._batch.add(this.toUrlAndQuery(), "PATCH", patchOptions, parser);
        }
    };
    Queryable.prototype.deleteImpl = function (deleteOptions, parser) {
        var _this = this;
        if (!this.hasBatch) {
            var client = new httpclient_1.HttpClient();
            return client.delete(this.toUrlAndQuery(), deleteOptions).then(function (response) {
                return _this.processHttpClientResponse(response, parser);
            });
        }
        else {
            return this._batch.add(this.toUrlAndQuery(), "DELETE", deleteOptions, parser);
        }
    };
    Queryable.prototype.processHttpClientResponse = function (response, parser) {
        if (!response.ok) {
            response.text().then(function (text) {
                logging_1.Logger.log({
                    data: response,
                    level: logging_1.LogLevel.Error,
                    message: text,
                });
                throw "Error making HttpClient request in queryable: " + response.statusText;
            });
        }
        if ((response.headers.has("Content-Length") && parseFloat(response.headers.get("Content-Length")) === 0)
            || response.status === 204) {
            return new Promise(function (resolve, reject) { resolve({}); });
        }
        return parser.parse(response);
    };
    return Queryable;
}());
exports.Queryable = Queryable;
var QueryableCollection = (function (_super) {
    __extends(QueryableCollection, _super);
    function QueryableCollection() {
        _super.apply(this, arguments);
    }
    QueryableCollection.prototype.filter = function (filter) {
        this._query.add("$filter", filter);
        return this;
    };
    QueryableCollection.prototype.select = function () {
        var selects = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            selects[_i - 0] = arguments[_i];
        }
        this._query.add("$select", selects.join(","));
        return this;
    };
    QueryableCollection.prototype.expand = function () {
        var expands = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            expands[_i - 0] = arguments[_i];
        }
        this._query.add("$expand", expands.join(","));
        return this;
    };
    QueryableCollection.prototype.orderBy = function (orderBy, ascending) {
        if (ascending === void 0) { ascending = true; }
        var keys = this._query.getKeys();
        var query = [];
        var asc = ascending ? " asc" : " desc";
        for (var i = 0; i < keys.length; i++) {
            if (keys[i] === "$orderby") {
                query.push(this._query.get("$orderby"));
                break;
            }
        }
        query.push("" + orderBy + asc);
        this._query.add("$orderby", query.join(","));
        return this;
    };
    QueryableCollection.prototype.skip = function (skip) {
        this._query.add("$skip", skip.toString());
        return this;
    };
    QueryableCollection.prototype.top = function (top) {
        this._query.add("$top", top.toString());
        return this;
    };
    return QueryableCollection;
}(Queryable));
exports.QueryableCollection = QueryableCollection;
var QueryableInstance = (function (_super) {
    __extends(QueryableInstance, _super);
    function QueryableInstance() {
        _super.apply(this, arguments);
    }
    QueryableInstance.prototype.select = function () {
        var selects = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            selects[_i - 0] = arguments[_i];
        }
        this._query.add("$select", selects.join(","));
        return this;
    };
    QueryableInstance.prototype.expand = function () {
        var expands = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            expands[_i - 0] = arguments[_i];
        }
        this._query.add("$expand", expands.join(","));
        return this;
    };
    return QueryableInstance;
}(Queryable));
exports.QueryableInstance = QueryableInstance;
